// extracted by mini-css-extract-plugin
module.exports = {"mainAd":"MainAd_mainAd__3Hp85","image":"MainAd_image__s2Cb7","description":"MainAd_description__1FYY1","buttons":"MainAd_buttons__3jucg"};